module.exports = __webpack_public_path__ + "static/media/expPink.9c786a1e.svg";